import { render, staticRenderFns } from "./LanguageToggler.vue?vue&type=template&id=0b86ff3f&scoped=true&"
import script from "./LanguageToggler.vue?vue&type=script&lang=js&"
export * from "./LanguageToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86ff3f",
  null
  
)

export default component.exports